import axios from 'axios';
import Session from '../storage/ClientStorage';

const axiosAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// This interceptor now only handles the user's authentication token.
axiosAPI.interceptors.request.use((config) => {
  const token = Session.get('user_token');

  if (token) {
    config.headers = Object.assign(
      {
        Authorization: `Bearer ${token}`
      },
      config.headers
    );
  }

  return config;
});

axiosAPI.interceptors.response.use(void 0, (error) => {
  // check for "session expired" response and logout user
  throw error;
});

export default axiosAPI;
